import Vue from 'vue'
import App from './schedule_templates/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const templateBuilder = document.getElementById('schedule-template-builder');

  if (templateBuilder) {
    new Vue({
      el: '#schedule-template-builder',
      render: h => h(App)
    }).$mount();
  }
});